import { ChevronDown } from 'assets/svg';
import T from 'core/i18n/t';
import TaskPanelComponent from 'core/job-panel';
import NoRecordsComponent from 'core/no-records/no-records-container';
import { paginationChannelScan } from 'core/pagination-optimized/redux/config';
import { PaginationConfig } from 'core/pagination-optimized/redux/types';
import TableComponent from 'core/table/table-container';
import { formatDateWithOffset } from 'core/utils/date-utils';
import { ExecuteCommandType, isDeviceOnline } from 'core/utils/deviceUtils';
import { TFunction } from 'i18next';
import React, { Component, Fragment } from 'react';
import { GeneralDeviceState } from '../general/redux/types';
import Topbar from '../topbar/topbar-container';
import mapper, { labelsChannelScan } from './redux/mapper';
import { ChannelScanResult, ChannelScanState } from './redux/types';

export interface ChannelComponentProps {
  fetch: (id: string, filter?: PaginationConfig) => void;
  toggleAccordion: (index: number) => void;
  hhid: string;
  id: string;
  results: ChannelScanState;
  startScan: any;
  t: TFunction;
  cancelCommand: any;
  general: GeneralDeviceState
  executeCommand: ExecuteCommandType
  offset: number;
}

export default class ChannelComponent extends Component<ChannelComponentProps> {
  componentDidMount() {
    if (
      !this.props.results ||
      !this.props.results.results ||
      !this.props.results.results[0] ||
      !this.props.results.results[0].totalElements
    ) {
      this.props.fetch(this.props.id, paginationChannelScan);
    }
  }

  render() {
    const { startScan, id, general, executeCommand, offset } = this.props
    return (
      <Fragment>
        <div className="columns width-full">
          <div className="column">
            <Topbar id={this.props.id}></Topbar>
          </div>
        </div>

        <div className="tile is-parent is-vertical has-margin-bottom-lg">
          <div className="columns">
            <div className="column is-narrow has-padding-bottom-none">
              <button
                className="button is-primary"
                onClick={() => executeCommand(isDeviceOnline(general), 'channels.tab_channel_scan', () => startScan(id, paginationChannelScan))}
                disabled={this.props.results.waitingCommandExecution}
              >
                <T>channels.tab_channel_scan</T>
              </button>
            </div>
          </div>

          {this.props.results.activityLog && this.props.results.activityLog.status !== 'SUCCEEDED' && (
            <ul className="panel has-margin-bottom-md">
              <TaskPanelComponent
                item={this.props.results.activityLog}
                showProgressBar
                cancel={this.props.cancelCommand}
                t={this.props.t}
                offset={offset}
              />
            </ul>
          )}

          <ul className="accordion">
            {this.props.results &&
            this.props.results.results &&
            this.props.results.results.length ? (
              this.props.results.results.map((item: ChannelScanResult, index: number) => (
                <li
                  className={`accordion-item ${
                    !item.accordionActive ? 'accordion-item-collapsed' : ''
                  }`}
                  key={index}
                >
                  <button
                    className="accordion-heading"
                    onClick={() => this.props.toggleAccordion(index)}
                  >
                    <span className="chevron">
                      <span className="chevron-text">{formatDateWithOffset(item.finishedAt, offset)}</span>
                      <span className="chevron-container accordion-chevron">
                        <ChevronDown className="icon icon-svg" />
                      </span>
                    </span>
                  </button>
                  <div className="accordion-content">
                    <TableComponent
                      id="channel-scan"
                      items={item.channelHistories && item.channelHistories.map(mapper)}
                      columns={labelsChannelScan(this.props.t)}
                    />
                  </div>
                </li>
              )))
            :
              <NoRecordsComponent />
            }
          </ul>

        </div>
      </Fragment>
    );
  }
}
